import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { noop } from 'lodash';
import { Menu, Tooltip } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import useAcceptAction from 'components/tables/data/revision/actions/hooks/use-accept-action';
import { useConfirm } from 'components/modals/message/MessageProvider';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by the revision technician to accept the revision.
 */
export default function AcceptAction({ revision, onStatusChange = noop, kind }: RevisionSingleActionProps) {
  const { acceptRevision } = useAcceptAction();
  const { confirm } = useConfirm();

  /**
   * Confirms the acceptance of the revision
   */
  const confirmAcceptRevision = () =>
    confirm({
      title: revision.kind === 'revision' ? 'Prijať revíznu správu' : 'Prijať formulár',
      content:
        revision.kind === 'revision'
          ? 'Naozaj si prajete prijať túto revíznu správu?'
          : 'Naozaj si prajete prijať tento formulár?',
      onConfirm: () => acceptRevision({ revision, onStatusChange }),
    });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Prijať" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="primary" size="md" onClick={confirmAcceptRevision}>
          <IconCheck />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button variant="primary" size="md" onClick={confirmAcceptRevision} leftIcon={<IconCheck />} w={188}>
        Prijať
      </Button>
    );
  }

  return (
    <Menu.Item color="gray.8" onClick={confirmAcceptRevision} icon={<IconCheck stroke={1.5} size={20} />}>
      Prijať
    </Menu.Item>
  );
}
